"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Scrollbar = void 0;
var _reactIntersectionObserver = require("react-intersection-observer");
var Styled = _interopRequireWildcard(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const getShadowStyles = function (position) {
  switch (position) {
    case "left":
      return {
        top: 0,
        left: 0,
        height: "calc(100% - var(--gradient-scroll-gutter))",
        width: "var(--gradient-size)",
        "--gradient-direction": "-90deg"
      };
    case "right":
      return {
        top: 0,
        right: "var(--gradient-scroll-gutter)",
        height: "calc(100% - var(--gradient-scroll-gutter))",
        width: "var(--gradient-size)",
        "--gradient-direction": "90deg"
      };
    case "top":
      return {
        top: 0,
        height: "var(--gradient-size)",
        width: "calc(100% - var(--gradient-scroll-gutter))",
        "--gradient-direction": "0deg"
      };
    case "bottom":
      return {
        bottom: "var(--gradient-scroll-gutter)",
        height: "var(--gradient-size)",
        width: "calc(100% - var(--gradient-scroll-gutter))",
        "--gradient-direction": "180deg"
      };
  }
  return {};
};
const getDetectorStyles = function (position) {
  switch (position) {
    case "left":
      return {
        top: 0,
        left: 0,
        width: "var(--detector-size)",
        height: "100%"
      };
    case "right":
      return {
        top: 0,
        right: 0,
        width: "var(--detector-size)",
        height: "100%"
      };
    case "top":
      return {
        top: 0,
        height: "var(--detector-size)",
        width: "100%"
      };
    case "bottom":
      return {
        bottom: 0,
        height: "var(--detector-size)",
        width: "100%"
      };
  }
  return {};
};
const useShadow = function (props) {
  const [ref, inView] = (0, _reactIntersectionObserver.useInView)({
    initialInView: true
  });
  const {
    position
  } = props;
  const detectorStyles = {
    ...getDetectorStyles(position)
  };
  const shadowStyles = {
    ...getShadowStyles(position),
    opacity: inView ? 0 : 1
  };
  return {
    inView,
    detectorProps: {
      ref,
      style: detectorStyles
    },
    shadowProps: {
      style: shadowStyles
    }
  };
};
const useOverflow = function () {
  const {
    shadowProps: ShadowTop,
    detectorProps: DetectorTop,
    inView: inViewTop
  } = useShadow({
    position: "top"
  });
  const {
    shadowProps: ShadowBottom,
    detectorProps: DetectorBottom,
    inView: inViewBottom
  } = useShadow({
    position: "bottom"
  });
  const {
    shadowProps: ShadowLeft,
    detectorProps: DetectorLeft,
    inView: inViewLeft
  } = useShadow({
    position: "left"
  });
  const {
    shadowProps: ShadowRight,
    detectorProps: DetectorRight,
    inView: inViewRight
  } = useShadow({
    position: "right"
  });
  return {
    detectors: {
      DetectorTop,
      DetectorLeft,
      DetectorBottom,
      DetectorRight
    },
    shadows: {
      inViewLeft,
      inViewRight,
      inViewTop,
      inViewBottom,
      ShadowTop,
      ShadowLeft,
      ShadowBottom,
      ShadowRight
    }
  };
};
const Detectors = function (props) {
  const {
    DetectorTop,
    DetectorLeft,
    DetectorBottom,
    DetectorRight
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Detector, {
      ...DetectorTop
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Detector, {
      ...DetectorLeft
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Detector, {
      ...DetectorBottom
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Detector, {
      ...DetectorRight
    })]
  });
};
const Shadows = function (props) {
  const {
    inViewLeft,
    inViewRight,
    inViewTop,
    inViewBottom,
    ShadowTop,
    ShadowLeft,
    ShadowBottom,
    ShadowRight
  } = props;
  const hasScrollHorizontal = !inViewLeft || !inViewRight;
  const hasScrollVertical = !inViewTop || !inViewBottom;
  const noGutter = {
    "--gradient-scroll-gutter": "0px"
  };
  const empty = {};
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Shadow, {
      ...ShadowTop,
      style: {
        ...ShadowTop.style,
        ...(!hasScrollHorizontal ? noGutter : empty)
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Shadow, {
      ...ShadowLeft,
      style: {
        ...ShadowLeft.style,
        ...(!hasScrollVertical ? noGutter : empty)
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Shadow, {
      ...ShadowBottom,
      style: {
        ...ShadowBottom.style,
        ...(!hasScrollHorizontal ? noGutter : empty)
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Shadow, {
      ...ShadowRight,
      style: {
        ...ShadowRight.style,
        ...(!hasScrollVertical ? noGutter : empty)
      }
    })]
  });
};
const Scrollbar = function (props) {
  const {
    children,
    style
  } = props;
  const {
    detectors,
    shadows
  } = useOverflow();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Scrollbar, {
    style: style,
    "data-testid": "Scrollbar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.OverflowScroller, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.OverflowContent, {
        children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(Detectors, {
          ...detectors
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Shadows, {
      ...shadows
    })]
  });
};
exports.Scrollbar = Scrollbar;
var _default = exports.default = Scrollbar;